// extracted by mini-css-extract-plugin
export default {"box":"contributor-box_box__8fuh1","inputSize":"contributor-box_inputSize__oHONM","deleteIcon":"contributor-box_deleteIcon__WFwHo"};